import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { VendorService } from '../../../services/vendor.service';

export interface VendorPickRow {
	supplierid: string;
	suppname: string;
	supptype: string | number;
	selected: boolean;
}

@Component({
	selector: 'app-vendor-supplier-multi-pick',
	templateUrl: './vendor-supplier-multi-pick.component.html',
	styleUrls: ['./vendor-supplier-multi-pick.component.scss']
})
export class VendorSupplierMultiPickComponent implements OnInit, OnChanges {
	@Input() filterSupptype = '';
	@Input() showIncludeInactiveToggle = true;
	@Output() selectedIdsChange = new EventEmitter<string[]>();

	vendorPickList: VendorPickRow[] = [];
	loading = false;
	includeInactive = false;

	constructor(private vendorService: VendorService) {}

	ngOnInit(): void {
		this.reload();
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['filterSupptype'] && !changes['filterSupptype'].firstChange) {
			this.applyVendorTypeToSelection();
		}
	}

	reload(): void {
		this.loading = true;
		this.vendorService.getVendorsPost({ inc_disabled: this.includeInactive }).subscribe({
			next: (rows: any[]) => {
				this.loading = false;
				const list = Array.isArray(rows) ? rows : [];
				const seen = new Set<string>();
				this.vendorPickList = [];
				for (const v of list) {
					const supplierid = String(v?.supplierid ?? '').trim();
					if (!supplierid || seen.has(supplierid)) {
						continue;
					}
					seen.add(supplierid);
					this.vendorPickList.push({
						supplierid,
						suppname: String(v?.suppname ?? ''),
						supptype: v?.supptype != null ? v.supptype : '',
						selected: true
					});
				}
				this.applyVendorTypeToSelection();
			},
			error: () => {
				this.loading = false;
				this.vendorPickList = [];
				this.emit();
			}
		});
	}

	get filteredRows(): VendorPickRow[] {
		const t = (this.filterSupptype && this.filterSupptype.toString().trim()) || '';
		if (!t) {
			return this.vendorPickList;
		}
		return this.vendorPickList.filter(r => String(r.supptype) === t);
	}

	applyVendorTypeToSelection(): void {
		const t = (this.filterSupptype && this.filterSupptype.toString().trim()) || '';
		if (t) {
			this.vendorPickList.forEach(r => {
				r.selected = String(r.supptype) === t;
			});
		} else {
			this.vendorPickList.forEach(r => {
				r.selected = true;
			});
		}
		this.emit();
	}

	selectAllVisible(): void {
		const vis = new Set(this.filteredRows.map(r => r.supplierid));
		this.vendorPickList.forEach(r => {
			if (vis.has(r.supplierid)) {
				r.selected = true;
			}
		});
		this.emit();
	}

	selectNoneVisible(): void {
		const vis = new Set(this.filteredRows.map(r => r.supplierid));
		this.vendorPickList.forEach(r => {
			if (vis.has(r.supplierid)) {
				r.selected = false;
			}
		});
		this.emit();
	}

	onRowToggle(): void {
		this.emit();
	}

	onIncludeInactiveChange(): void {
		this.reload();
	}

	getSelectedIds(): string[] {
		return this.vendorPickList.filter(r => r.selected).map(r => r.supplierid);
	}

	trackBySupplier(_index: number, row: VendorPickRow): string {
		return row.supplierid;
	}

	private emit(): void {
		this.selectedIdsChange.emit(this.getSelectedIds());
	}
}
